import { React } from '@api'
import { Autorenew } from "@material-ui/icons"
import * as css from './AutoRenewAnimationIcon.css'
interface IAutoRenewIconComponentProps {
    animateIcon: boolean,
}

export const AutoRenewAnimationIconComponent = (props: IAutoRenewIconComponentProps) => {
    return <Autorenew className={props.animateIcon? css.spinnerAnimate : css.spinner} />
}


// WEBPACK FOOTER //
// ./src/modules/common/components/AutoRenewAnimationIcon.tsx